import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { CommonRegEx, TestListService, UserService } from '@nrwl/common-lib';

@Component({
  selector: 'nrwl-test-identity',
  templateUrl: './test-identity.component.html',
  styleUrls: ['./test-identity.component.scss']
})
export class TestIdentityComponent implements OnInit {
  @Input() testName: string;
  @Input() customer: string;
  @Input() technician = '';
  @Input() contact = '';
  @Input() email = '';
  @Input() phone = '';
  @Input() technicianId = '';
  @Input() comments = '';
  @Input() editMode = false;
  @Input() showCustomerTechnician?: boolean = true;
  @Output() updateTestIdentity = new EventEmitter();
  @ViewChild('currentForm', { static: true }) form: NgForm;
  allTestNames: Array<string> = [];
  nameExist: boolean;
  emailRegEx: RegExp;
  rows = 1;

  constructor(private userService: UserService, private testListService: TestListService) {}

  ngOnInit(): void {
    this.emailRegEx = CommonRegEx.EMAIL;
    if (!this.editMode) {
      this.testName = `${this.testName}-${this.userService.getUserName()}-${new Date().getTime()}`;
      this.technician = this.userService.getUserName();
    }
    this.testListService.getValuesAsync().subscribe(data => {
      this.allTestNames = data.map(item => item.escapedName);
    });
    this.updateIdentity();
  }
  updateIdentity(): void {
    this.updateTestIdentity.emit({
      testName: this.testName,
      customer: this.customer,
      contact: this.contact,
      email: this.email,
      phone: this.phone,
      technicianId: this.technicianId,
      comments: this.comments,
      technician: this.technician,
      isValidName: this.testName
        ? !this.isValidtestName() && !this.nameExist && this.form.controls.email?.valid
        : false
    });
  }

  isValidtestName(): boolean {
    if (this.testName) {
      this.checkIfNameAlreadyExist();
      const pattern = new RegExp('[?%/]');
      if (pattern.test(this.testName)) {
        return true;
      }
      return false;
    }
  }

  checkIfNameAlreadyExist(): void {
    if (this.editMode) {
      this.allTestNames = this.allTestNames.filter(name => name !== this.testName);
    }
    if (this.allTestNames.some(item => item.toLowerCase() === this.testName.toLowerCase())) {
      this.nameExist = true;
    } else {
      this.nameExist = false;
    }
  }
}
